


















// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Model
import { HolidayForm } from '@/models/config'

// Components
import { FormCreateEditHoliday } from '@/components/config'

@Component({
    name: 'ModalCreateEditReasonForPermission',
    components: {
        FormCreateEditHoliday
    }
})
export default class ModalCreateEditReasonForPermission extends Vue {
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ required: true }) holiday!: HolidayForm

    get title () {
        if (this.actionForm === 'save') {
            return 'Crear Nuevo Día Festivo'
        }
        return 'Editar Día Festivo'
    }
}
